/**
 * @flow
 * @relayHash 7a6d89a25e2ea7fde1e4dfad3767b246
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type itemEventsShownMutationVariables = {|
  input: {
    userId: string;
    clientMutationId?: ?string;
  };
|};
export type itemEventsShownMutationResponse = {|
  +itemEventsShown: ?{|
    +favoriteNotifications: ?{|
      +hasNewEvents: ?boolean;
    |};
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ItemEventsShownInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "itemEventsShownMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ItemEventsShownInput!"
          }
        ],
        "concreteType": "ItemEventsShownPayload",
        "name": "itemEventsShown",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "name": "favoriteNotifications",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "hasNewEvents",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": "dibs-buyer-layout/191.2.14-2018-10-30T15:17:02.390Z/itemEventsShownMutation",
  "kind": "Batch",
  "metadata": {},
  "name": "itemEventsShownMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ItemEventsShownInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "itemEventsShownMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ItemEventsShownInput!"
          }
        ],
        "concreteType": "ItemEventsShownPayload",
        "name": "itemEventsShown",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "name": "favoriteNotifications",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "hasNewEvents",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
